import { createContext } from "react";
import { tToggleButtonCtxProps } from "./types";
export const Context = createContext<tToggleButtonCtxProps>(null as any);
